// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonPrimaryToggleOff = 1;
var ButtonSecondaryToggleOff = 1;
var ButtonPrimaryToggleGroupOn = 2;
var ButtonSecondaryToggleGroupOn = 2;
var ButtonTertiaryToggleGroupOn = 2;
var PaginationNumbered = 2;
var BorderWidthSemanticsAll = {
  ButtonPrimaryToggleGroupOn: ButtonPrimaryToggleGroupOn,
  ButtonPrimaryToggleOff: ButtonPrimaryToggleOff,
  ButtonSecondaryToggleGroupOn: ButtonSecondaryToggleGroupOn,
  ButtonSecondaryToggleOff: ButtonSecondaryToggleOff,
  ButtonTertiaryToggleGroupOn: ButtonTertiaryToggleGroupOn,
  PaginationNumbered: PaginationNumbered
};

export { BorderWidthSemanticsAll, ButtonPrimaryToggleGroupOn, ButtonPrimaryToggleOff, ButtonSecondaryToggleGroupOn, ButtonSecondaryToggleOff, ButtonTertiaryToggleGroupOn, PaginationNumbered, BorderWidthSemanticsAll as default };
